<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>{{ 'form.addReasonOptions' | t }}</h2>
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="warn" mat-button mat-dialog-close>{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" [disabled]="form.invalid" mat-button type="submit">
      {{ 'common.save' | t }}
    </button>
  </mat-dialog-actions>
</form>
